import styled from "styled-components";
import { media } from "../../styles/breakpoints";

const HeaderNavBarStyled = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;

  ${media.wide`
    gap: 24px;
  `}

  .header-navbar__link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    color: ${(props) => props.theme.colour.text.inverse};
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    border-radius: ${(props) => props.theme.border.borderRadiusLarge};
    transition: ${(props) => props.theme.transitions.normal};
    background-color: transparent;
    border: 2px solid transparent;
    cursor: pointer;
    min-height: 40px;
    min-width: 80px;

    ${media.wide`
      padding: 12px 20px;
      font-size: 1.125rem;
      min-width: 100px;
    `}

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      transform: translateY(-1px);
      border-color: rgba(255, 255, 255, 0.2);
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colour.border.focus};
      outline-offset: 2px;
      background-color: rgba(255, 255, 255, 0.05);
    }

    &.active {
      background-color: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
        transform: translateY(-1px);
      }
    }
  }
`;

export default HeaderNavBarStyled;
